<template>
    <v-form
        ref="form"
    >
        <v-autocomplete
            v-model="model"
            :items="items"
            :loading="isFetch"
            :search-input.sync="search"
            no-filter
            label="Поиск адреса"
            placeholder="Введите адрес или guid объекта"
            prepend-icon="mdi-database-search"
            return-object
        ></v-autocomplete>
        <v-btn
            :disabled="!allowSave"
            color="success"
            class="mr-4"
            @click="onSave"
        >
            Добавить
        </v-btn>
    </v-form>
  </template>
  
  <script>
  import _ from 'lodash';
  import {mapGetters, mapActions} from 'vuex';
  import * as organizationApi from '@/api/organizations';
  export default {
      name: 'FiasHouseForm',
      components:{},
      data(){
          return {
            model: null,
            entries: [],
            isFetch: false,
            search: null
          }
      },
  
      created(){
      },
      watch:{
        search (){
            this.onInputSearch();
        }
      },

      methods: {
        ...mapActions('notifications', ['SHOW_MESSAGE', 'SHOW_ERROR', 'SHOW_SUCCESS']),
        async load(){
            this.isFetch = true;
            try{
                let { data } = await organizationApi.fiasHousesSearch(this.search);
                this.entries.splice(0, this.entries.length, ...data);
            }catch(e){
                console.log(e);
            }finally{
                this.isFetch = false;
            }
        },
        onInputSearch: _.debounce(function(){
            if(this.search != null){
                this.load();
            }
        }, 1000),

        onSave(){
            if( ! this.allowSave ){
                return;
            }
            this.isFetch = true;
            organizationApi.organizationFiasHouseSave(this.ID_WORK_SPACE, this.ORGANIZATION_ID, this.savingModel)
                .then(({data}) => {
                    this.SHOW_SUCCESS(data.message);
                    this.$emit('added-address', this.savingModel)
                    this.clearSearch();
                }).catch(err => {
                    console.log(err);
                    this.SHOW_ERROR('Произошла ошибка сохранения. Повторите попытку');
                }).finally(() => {
                    this.isFetch = false;
                });
        },
        clearSearch(){
            this.model = null;
            this.search = null;
            this.entries.splice(0, this.entries.length);
        }
      },
      computed: {
          ...mapGetters( 'workspace', ['ID_WORK_SPACE', 'ORGANIZATION_ID']),
          items(){
            return this.entries.map(item => {
                return {text: item.value, value: item}
            });
          },
          allowSave(){
            return ! this.isFetch && this.model !== null && this.model.value.objectLevel === "HOUSE";

        },
        savingModel(){
            if( this.model === null){
                return {};
            }
            return {
                guid: this.model.value.guid,
                full_name: this.model.value.unrestrictedValue
            };
        }
      }
  }
  </script>